module.exports = __webpack_public_path__ + "img/home_header.c7d3119e.svg";